import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import moment from "moment";
import { routes } from "../../../utlis/provider/routes.utlis";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { api } from "../../../utlis/provider/api.utlis";
import ApiService from "../../../core/services/ApiService";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
import Searchicon from "../../../assets/provider/images/search1.svg";

const AddAds = () => {
  const navigate = useNavigate();
  const [categories, setCategory] = useState([]);
  const [subCategories, setSubCategory] = useState([]);
  const [tags, setTag] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addAd, setAddAd] = useState({ status: false });
  const [coupon, setCoupon] = useState();
  const [openCouponModal, setCouponModal] = useState(false);
  const options = [];

  const adsCoupon = async (api) => {
    setLoading(true);
    const responseApply = await ApiService.getAPIWithAccessToken(api);
    if (responseApply.data.status && responseApply.data.statusCode === 200) {
      setCoupon(responseApply.data.data);
    } else {
      setCoupon();
    }
    setLoading(false);
  };

  const initialValues = {
    title: "",
    description: "",
    category: "",
    service_type_id: "",
    start_date: null,
    end_date: null,
    image: null,
    tags: [],
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!").min(8),
    category: Yup.string().required("Category is required!"),
    service_type_id: Yup.string().required("Sub Category is required!"),
    start_date: Yup.date().nullable().required("Start Date is required!"),
    end_date: Yup.date()
      .nullable()
      .required("End Date is required!")
      .min(Yup.ref("start_date"), "End date can't be before Start date"),
    image: Yup.mixed().required("Image is required!"),
    tags: Yup.array().min(1, "At least one tag is required!"),
  });

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  const getSubCategoryList = async (id) => {
    const response = await ApiService.getAPIWithAccessToken(
      api.categoryList + `?categoryid=${id}`
    );
    if (response?.data?.status && response?.data?.statusCode === 200) {
      setSubCategory(response?.data?.data?.categories);
    } else setSubCategory([]);
  };

  const getTagsList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      response.data.data.tags.forEach((element) => {
        options.push({ value: element.id, label: element.name });
      });
      setTag(options);
    } else options = [];
  };

  const addAds = async (formValue, { resetForm }) => {
    setLoading(true);
    const form = new FormData();
    form.append("title", formValue.title);
    form.append("description", formValue.description);
    form.append("service_type_id", formValue.service_type_id);
    form.append("image", formValue.image);
    form.append(
      "start_date",
      moment(formValue.start_date).format("yyyy-MM-DD")
    );
    form.append("end_date", moment(formValue.end_date).format("yyyy-MM-DD"));
    formValue.tags.forEach((ele) => {
      form.append("tags[]", ele.value);
    });
    form.append("payment", coupon?.adsLimitExpired == true ? true : false);
    
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.addAdvertisement,
      form
    );
    setSubCategory([]);
    if (response.data.status) {
      console.log(response.data);
      toast.success(response.data.message);
      resetForm();
      if(coupon?.adsLimitExpired == false) {
        navigate(routes.advertisement);
      } else {
        let formPayment = {
          couponCode: coupon?.currentAppliedCoupon?.coupon_code ?? "",
          ads_id: response.data.data.id.toString(),
          amount: coupon?.adsPrice.toString() ?? "0",
        };
        const responsePayment = await ApiService.postAPIWithAccessToken(
          api.paymentAdvertisement,
          formPayment
        );
        if (responsePayment.data.status) {
          console.log(responsePayment.data);
          toast.success(responsePayment.data.message);
          window.location.href = responsePayment.data.data.approvalUrl
        } else {
          toast.error(responsePayment.data.message);
        }
      }
    } else {
      toast.error(response.data.message);
    }

    setLoading(false);
  };

  const applyCoupon = async (formValue) => {
    if (formValue === "" || formValue === null || formValue === undefined) {
      toast.error("Please enter a coupon code.");
      return;
    }
    setLoading(true);
    const responseApply = await ApiService.getAPIWithAccessToken(
      api.adsCouponApply + `?couponCode=${formValue}`
    );
    if (responseApply.data.status && responseApply.data.statusCode === 200) {
      setCoupon(responseApply.data.data);
      toast.success(responseApply.data.message);
      setCouponModal(false);
    } else {
      setCoupon(responseApply.data.data);
      toast.error(responseApply.data.message);
    }
    setLoading(false);
  };

  const cancelCoupon = async (couponCode) => {
    setLoading(true);
    let form = JSON.stringify({
      couponCode: couponCode ?? "",
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.cancelCoupon,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      adsCoupon(api.adsCouponApply);
      toast.success(response.data.message);
      setCouponModal(false);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCategoryList(api.categoryList);
    getTagsList(api.tagsList);
    adsCoupon(api.adsCouponApply);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="carenetwork-section mt-3 pt-3">
          <div className="care-title-header">
            <h2 className="heading-title">Post New Advertisement</h2>
          </div>
          <div className="post-newjob-content">
            <div className="post-job-form">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={addAds}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form id="add-post-form">
                    <div className="post-job-card">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Title</h4>
                            <Field
                              type="text"
                              className="form-control todo-list-input"
                              name="title"
                              placeholder="Enter Title"
                            />
                            <ErrorMessage
                              name="title"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>Category</h4>
                            <Field
                              as="select"
                              name="category"
                              className="form-control todo-list-input"
                              onChange={(e) => {
                                const categoryId = e.target.value;
                                setFieldValue("category", categoryId);
                                getSubCategoryList(categoryId);
                              }}
                            >
                              <option value="">Select Category</option>
                              {categories.map((ele, idx) => (
                                <option key={idx} value={ele.id}>
                                  {ele.name}
                                </option>
                              ))}
                            </Field>
                            <ErrorMessage
                              name="category"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>Sub Category</h4>
                            <Field
                              as="select"
                              name="service_type_id"
                              className="form-control todo-list-input"
                            >
                              <option value="">Select Sub Category</option>
                              {subCategories.map((ele, idx) => (
                                <option key={idx} value={ele.id}>
                                  {ele.name}
                                </option>
                              ))}
                            </Field>
                            <ErrorMessage
                              name="service_type_id"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>Start Date</h4>
                            <DatePicker
                              selected={values.start_date}
                              onChange={(val) =>
                                setFieldValue("start_date", val)
                              }
                              className="form-control todo-list-input"
                              placeholderText="Select Start Date"
                            />
                            <ErrorMessage
                              name="start_date"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>End Date</h4>
                            <DatePicker
                              selected={values.end_date}
                              onChange={(val) => setFieldValue("end_date", val)}
                              className="form-control todo-list-input"
                              placeholderText="Select End Date"
                            />
                            <ErrorMessage
                              name="end_date"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>Tags</h4>
                            <Select
                              isMulti
                              name="tags"
                              options={tags}
                              value={values.tags}
                              onChange={(selectedOptions) =>
                                setFieldValue("tags", selectedOptions)
                              }
                            />
                            <ErrorMessage
                              name="tags"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>Upload Image</h4>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                setFieldValue("image", e.target.files[0])
                              }
                              className="form-control todo-list-input"
                            />
                            <ErrorMessage
                              name="image"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <h4>Description</h4>
                          <Field
                            as="textarea"
                            className="form-control todo-list-input"
                            name="description"
                            placeholder="Enter Description"
                          />
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="post-job-card">
                      <div className="row">
                        <div className="col-md-6">
                          {coupon?.adsLimitExpired == true &&
                          coupon?.isCouponApplied == false ? (
                            <div className="my-2">
                              <span
                                style={{ color: "var(--blue)", cursor: "pointer" }}
                                className="text-decoration-underline"
                                onClick={() => setCouponModal(true)}
                              >
                                Have a Coupon Code?
                              </span>
                            </div>
                          ) : null}

                          {coupon?.isCouponApplied == true ? (
                            <div className="w-100">
                              <div class="promo-container">
                                <div class="promo-box">
                                  <div class="promo-left">
                                    <span class="promo-icon">✔️</span>
                                    <div>
                                      <p class="promo-code">
                                        Coupon Code:{" "}
                                        <strong>
                                          {coupon?.currentAppliedCoupon?.coupon_code ?? ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      cancelCoupon(
                                        coupon?.currentAppliedCoupon?.coupon_code ?? ""
                                      );
                                    }}
                                    class="promo-remove"
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          
                        </div>
                        <div className="col-md-6">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => navigate(-1)}
                              className="btn-bl mx-2"
                            >
                              Back
                            </button>
                            <button className="btn-gr" type="submit">
                              {coupon?.adsLimitExpired == true ? (
                              <span className="price-text">
                                {coupon?.adsPrice ? `Pay $${coupon.adsPrice} and ` : ""} Post Advertisement 
                              </span>
                            ) : 'Post Advertisement'}
                              
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
              


              {openCouponModal && (
                <div className="text-center w-100 d-flex justify-content-start align-items-start">
                  <div className="nwi-input-wrapper">
                    <input
                      type="text"
                      name="text"
                      className="nwi-input"
                      placeholder="Enter Coupon Code"
                      autoComplete="off"
                    />
                    <button
                      onClick={() => {
                        applyCoupon(document.querySelector(".nwi-input").value);
                      }}
                      className="nwi-Subscribe-btn"
                    >
                      Apply
                    </button>
                  </div>
                  <div className="mx-2">
                    <i
                      onClick={() => {
                        setCouponModal(false);
                      }}
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      className="fa fa-close"
                    ></i>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAds;
